/**
 * Brands Listing Vue Component
 * ------------------------------------------------------------------------------
 * Template in sections/template-brands.liquid
 *
 */

import axios from 'axios';
import Vue from 'vue';
import Vuelidate from 'vuelidate';

import Collapsible from './collapsible.vue';
import Slick from 'vue-slick';
import Tab from './tab';
import Tabs from './tabs';

import { getElementOffset } from '../utils/helpers';
import { getBranchDataUrl, getAppointmentCreateUrl, getAppointmentDataUrl, xhrRequestConfig } from '../utils/api';
import { required } from 'vuelidate/lib/validators';

Vue.use(Vuelidate);

const BRANCH_DATA_URL = getBranchDataUrl();
const APPOINT_DATA_URL = getAppointmentDataUrl();
const APPOINT_CREATE_URL = getAppointmentCreateUrl();

const phoneTestRegex = new RegExp(/^(0[1-9])(\d{8})$/);
const phoneRegexIsValid = value => {
    const phoneValid = phoneTestRegex.test(value);
    return phoneValid;
}

export default {
    components: {
        Collapsible,
        Tab,
        Tabs,
        Slick
    },

    props: {
        customerData: {
            type: Object,
            default: null
        },
        bookingTimeLabel: {
            type: Object
        },
        errorMessageTitle: {
            type: String
        }
    },

    data() {
        return {
            // General
            step: 1,
            isLoading: true,
            isSubmitting: false,
            storeData: [],
            branchData: null,
            loadingDateSelect: false,
            isAnyOptometrist: true,
            anyOptometristID: null,
            isReadingMore: true,

            showLeaveAlert: false,
            removeLeaveAlert: false,

            // Errors from Middleware
            showErrorMessages: false,
            // errorMessageTitle: false,
            errorMessages: [],

            // Booking
            firstOptom: null,
            selectedOptometrist: null,
            booking: {
                branch_identifier: null,
                optometrist_id: null,
                type: null,
                date: null,
                time: null,
            },
            currentUrl: new URL(window.location.href),
            
            // User
            user: {
                email: null,
                title: null,
                first_name: null,
                last_name: null,
                date_of_birth: null,
                phone: null,
                rejects_marketing: null, // Inverse the marketing value so we dont have to do weird stuff in the v-model
            }
        }
    },

    computed: {
        currentBranch() {
            let temp = [...this.storeData.nsw, ...this.storeData.vic];
            return temp.find( store => store.identifier === this.booking.branch_identifier );
        },
        optometristSchedule() {
            if (!this.booking.date && !this.selectedOptometrist) return false;
            
            let schedule = this.selectedOptometrist.schedule[`${this.booking.date}`],
                scheduleFormatted = {
                    "morning": 
                    [ ...Object.entries(schedule).map( time => {
                        let timeParsed = parseInt(time[0].replace(':',''));
                        if (timeParsed <= 1200 && time[1]) return time[0];
                    }) ].filter( value => value),
                
                    "afternoon": 
                    [ ...Object.entries(schedule).map( time => {
                        let timeParsed = parseInt(time[0].replace(':',''));
                        if ( timeParsed > 1200 && timeParsed < 1700 && time[1]) return time[0];
                    }) ].filter( value => value),
                
                    "evening": 
                    [ ...Object.entries(schedule).map( time => {
                        let timeParsed = parseInt(time[0].replace(':',''));
                        if ( timeParsed >= 1700 && time[1]) return time[0];
                    }) ].filter( value => value)
                };

            return scheduleFormatted
        },
        bookingTypeLong() {
            let bookingTypes = {
                'ET': 'Eye Test',
                'CLC': 'Contact Lens Consultation'
            }
            return bookingTypes[this.booking.type]
        },
        optometristIsAvailable() {
            if (!this.selectedOptometrist) return false;
            return Object.values(this.selectedOptometrist.schedule).some( date => !!date );
        }
    },


    validations() {
        return {
            booking: {
                date: {
                    required
                },
                time: {
                    required
                }
            },
            user: {
                email: {
                    required
                },
                title: {
                    required
                },
                first_name: {
                    required
                },
                last_name: {
                    required
                },
                date_of_birth: {
                    required
                },
                phone: {
                    required,
                    phoneRegexIsValid
                }
            }
        }
    },

    watch: {
        'booking.optometrist_id': function() {
            this.$v.$reset();

            this.$nextTick( () => {
                this.booking.date = null;
                this.booking.time = null;
                this.loadingDateSelect = true;
                if(this.booking.optometrist_id != 'any'){
                    this.isAnyOptometrist = false;
                } else {
                    // this.isAnyOptometrist = true;
                }
            });
            setTimeout( () => {
                this.$nextTick( () => {
                    if(this.booking.optometrist_id == 'any'){
                        this.isAnyOptometrist = true;
                        
                        let scheduleComp = [];
                        let pushedDates = [];
                        this.branchData.optometrists.filter( sched => {
                            Object.entries(sched.schedule).filter(dates =>  {
                                
                                if(!!dates[1]){
                                    if(pushedDates.includes(dates[0])) {
                                      
                                      let selectedDate = scheduleComp[pushedDates.indexOf(dates[0])];

                                      Object.entries(dates[1]).forEach(
                                        ([key, value]) => {
                                          if(value) {
                                            selectedDate[1][key] = JSON.parse(JSON.stringify(value));
                                          }
                                        }
                                      );
                                    }else{
                                      pushedDates.push(JSON.parse(JSON.stringify(dates[0])));
                                      scheduleComp.push(JSON.parse(JSON.stringify(dates)))
                                    }

                                }
                            })
                        })
                        let toObj = scheduleComp.sort((orderA, orderB) => new Date(orderA[0]) - new Date(orderB[0]));
                        let allOptometrists = this.branchData.optometrists.find( optometrist => optometrist.id === this.firstOptom);
                        this.selectedOptometrist = JSON.parse(JSON.stringify(allOptometrists));
                        this.selectedOptometrist.schedule = Object.fromEntries(toObj);
                        let filteredSchedule = !!this.selectedOptometrist ? Object.entries(this.selectedOptometrist.schedule).filter( date => !!date[1] ) : [],
                        firstAvailableDate = !!filteredSchedule.length ? filteredSchedule[0][0] : null;
          
                        this.booking.date = firstAvailableDate;
                        this.loadingDateSelect = false;
                        
                    } else {
                      
                        this.selectedOptometrist = this.branchData.optometrists.find( optometrist => optometrist.id === this.booking.optometrist_id);
                        let filteredSchedule = !!this.selectedOptometrist ? Object.entries(this.selectedOptometrist.schedule).filter( date => !!date[1] ) : [],
                            firstAvailableDate = !!filteredSchedule.length ? filteredSchedule[0][0] : null;
                        
                        this.isAnyOptometrist = false;
                        this.booking.date = firstAvailableDate;
                        this.loadingDateSelect = false;
                    }
                    
                });
            }, 300)
        },
        'booking.date': function() {
            
            this.$v.$reset();

            this.$nextTick( () => {
                this.booking.time = null;
                if(this.isAnyOptometrist){
                    this.booking.optometrist_id = 'any';
                    let bookingDate = this.booking.date;
                    let appointsData = this.branchData.optometrists.map( optometrist => {
                        // get the whole object
                        let optomSchedule = optometrist.schedule[bookingDate],
                            // output just the values
                            optomScheduleDatesAvailable = !!optomSchedule ? Object.values(optomSchedule) : [false],
                            // If there is any availability (by the value not being NULL)...
                            hasAvailableDates = optomScheduleDatesAvailable.some( availability => !!availability);

                        // then return the optometrist identifier and the earliest time slot they have
                        if (hasAvailableDates) {
                            // filter out the available dates, then we can grab the first one
                            let earliestAppointment = Object.entries(optomSchedule).filter( date => !!date[1]);
                            return [ optometrist.id,optometrist.given_name,optometrist.surname, parseInt(earliestAppointment[0][0].replace(':', '')), optometrist.default];

                        } else {
                            // otherwise can ignore
                            return false
                        }

                    }).filter(optometrist => !!optometrist);
                    const defaultOptometrist = appointsData.find((data) => data[4]);
                    const defaultOrFirstOptometrist = defaultOptometrist ? defaultOptometrist : appointsData[0];
                    this.anyOptometristID = defaultOrFirstOptometrist[0];
                    this.selectedOptometrist.id = defaultOrFirstOptometrist[0];
                    this.selectedOptometrist.given_name = defaultOrFirstOptometrist[1];
                    this.selectedOptometrist.surname = defaultOrFirstOptometrist[2];
                }
                
            })
        },
        'booking.time': function() {
            
            this.$v.$reset();

            this.$nextTick( () => {
                if(this.isAnyOptometrist && this.booking.time){
                    this.booking.optometrist_id = 'any';
                    let bookingDate = this.booking.date;
                    let bookingTime = this.booking.time;
                    let appointsData = this.branchData.optometrists.map( optometrist => {
                        // get the whole object
                        let optomSchedule = optometrist.schedule[bookingDate],
                            // output just the values
                            optomScheduleDatesAvailable = !!optomSchedule ? Object.values(optomSchedule) : [false],
                            
                            // If there is any availability (by the value not being NULL)...
                            hasAvailableDates = optomScheduleDatesAvailable.some( availability => !!availability);


                        // then return the optometrist identifier and the earliest time slot they have
                        if (hasAvailableDates) {
                            // filter out the available dates, then we can grab the first one
                            let earliestAppointment = Object.entries(optomSchedule).filter( date => date[0] == bookingTime);
                            if(earliestAppointment[0][1]){
                                return [ optometrist.id,optometrist.given_name,optometrist.surname, parseInt(earliestAppointment[0][0].replace(':', '')), optometrist.default];
                            }
                        } else {
                            // otherwise can ignore
                            return false
                        }
                    }).filter(optometrist => !!optometrist);
                    const defaultOptometrist = appointsData.find((data) => data[4]);
                    const defaultOrFirstOptometrist = defaultOptometrist ? defaultOptometrist : appointsData[0];
                    this.anyOptometristID = defaultOrFirstOptometrist[0];
                    this.selectedOptometrist.id = defaultOrFirstOptometrist[0];
                    this.selectedOptometrist.given_name = defaultOrFirstOptometrist[1];
                    this.selectedOptometrist.surname = defaultOrFirstOptometrist[2];
                }
                
            })
        }
    },

    created() {
    
        axios.get(BRANCH_DATA_URL, xhrRequestConfig)
        .then((response) => {
            this._reformatData(response.data.data.branches);
        })
        .catch((error) => {
            console.log(error);
        });
    },

    mounted() {

        window.stockistBookNowButtonClicked = this.formSelectStore;

        
        // Prefill data for logged in user
        if (this.customerData !== null) {
            this.user.first_name = this.customerData.first_name;
            this.user.last_name = this.customerData.last_name;
            this.user.email = this.customerData.email;
            this.user.phone = this.customerData.phone;
        }

        const observer = new MutationObserver(() => {
            const mobileHeadingCopy = this.$el.querySelector('.copy.copy-mobile')
            if (mobileHeadingCopy) {
                if (mobileHeadingCopy.scrollHeight > parseFloat(window.getComputedStyle(mobileHeadingCopy).lineHeight.replace('px', '')) * 3) {
                    this.isReadingMore = false
                }
                observer.disconnect()
            }
        })
        observer.observe(document, {attributes: false, childList: true, characterData: false, subtree:true})

        // Store ID in URL
        const storeId = new URLSearchParams(this.currentUrl.search).get('store')
        if (storeId) {
            this.formSelectStore(storeId)
        }
    },

    updated() {
        this.$nextTick(function () {
            // wait for all the bits to be ready so we can then load the widget
            let stockistLoadInterval = setInterval( loadStockist, 500);
            function loadStockist() {
                if ((typeof Stockist === 'undefined')) {
                    if (!!document.querySelector('[data-stockist-widget-tag]')) {
                        // add Stockist Script
                        (
                            function(s,t,o,c,k){
                                c = s.createElement(t);
                                c.src = o;
                                c.async = 1;
                                k = s.getElementsByTagName(t)[0];
                                k.parentNode.insertBefore(c,k);
                            }
                        )(document, 'script', '//stockist.co/embed/v1/widget.min.js');
                    }
                } else if ((typeof Stockist !== 'undefined')) {
                    clearInterval(stockistLoadInterval);
                }
            };
        });
    },
    
    methods: {

        ////////////////////////////////////////////
        // PRIVATE
        ////////////////////////////////////////////
        
        _reformatData(data) {
            /*
                Remove some branches, either ones that will cause problems or were specifically asked to be excluded:
                - 1001 Optical Online | NTL
                - 1001 Mount Druitt Store | MTD
                - Eyes only paramatta | PAE
                - branches with 0 optometrists
            */
            let cleanedData = data.filter( branch => {
                let isNTL = branch.identifier.toLowerCase() === 'ntl', // NTL = 1001 optical online store
                    isPAE = branch.identifier.toLowerCase() === 'pae', // PAE = Eyes only parramatta store
                    isMTD = branch.identifier.toLowerCase() === 'mtd', // MTD = Mount Druitt store
                    hasNoOptometrists = branch.optometrists.length === 0;

                if (!isNTL && !isPAE && !isMTD && !hasNoOptometrists) return branch;
            }),
            tempStores = {
                "nsw": cleanedData.filter( branch => branch.state.toLowerCase() === 'nsw'),
                "vic": cleanedData.filter( branch => branch.state.toLowerCase() === 'vic')
            };
            
            this.storeData = tempStores;
            this.isLoading = false;
        },

        _resetFormData(resetWhat) {
            // TRUE = everything, go back to start, just refresh the page
            if (resetWhat) {
                location.reload();
            } 
            
            // FALSE = just appointment and user data
            else {
                
                this.$v.$reset();

                // Booking
                // this.booking.date = null;
                // this.booking.time = null;
                // this.booking.optometrist_id = null;
                // let tempDefault = this.branchData.optometrists.find( optometrist => !!optometrist.default );
                this.booking.optometrist_id = this.isAnyOptometrist ? 'any' : this.booking.optometrist_id;
                
                // User
                this.user.title = null;
                this.user.date_of_birth = null;
                this.user.rejects_marketing = null;
                
                // Prefill data for logged in user
                if (this.customerData !== null) {
                    this.user.first_name = this.customerData.first_name;
                    this.user.last_name = this.customerData.last_name;
                    this.user.email = this.customerData.email;
                    this.user.phone = this.customerData.phone;
                } else {
                    this.user.email = null;
                    this.user.first_name = null;
                    this.user.last_name = null;
                    this.user.phone = null;
                }
            }
                
        },

        _validation(stepToValidate) {
            this._handleErrors(false);
            
            // Validation and reformatting
            if (stepToValidate === 3) {
                this.$v.booking.$touch();
                return !this.$v.booking.$error;
            } 
            else if (stepToValidate === 4) {
                this.$v.user.$touch();
                if (!!this.$v.user.$error) {
                    setTimeout( () => {
                        let headerOffset = (document.querySelector('.header-wrapper').offsetHeight + 40),
                            firstError = document.querySelector('.booking__review .field--error'),
                            offset = getElementOffset(firstError).top - headerOffset;
                        window.scroll({ top: offset, left: 0, behavior: 'smooth' });
                    }, 150)
                }
                return !this.$v.user.$error;
            }
        },

        _handleErrors(show, data) {
            var errors;
            
            if (!!show) {

                // wrapping in a try catch for a fallback
                try {   

                    if (data.error) {
                        errors = Object.entries(JSON.parse(data.error)).map( error => error.flat(1).join(' '));
                    } else if (data.reasons) {
                        errors = Object.values(data.reasons).flat(1);
                    } else if (data.message) {
                        let formattedMessage = JSON.parse(data.message);
                        errors = Object.values(formattedMessage).map( error => {
                            return error.message;
                        });
                    }
                }
                catch {
                    errors = [];
                }
                
                this.errorMessages = errors;
                this.showErrorMessages = true;
                window.scroll({ top: 0, left: 0, behavior: 'smooth' });
                
            } else {
                this.errorMessages = [];
                this.showErrorMessages = false;
            }
        },

        _findFirstOrDefaultAvailableAppointment() {
            let firstAvailableOptometrist = null,
                // get the schedule dates for later reference
                dateKeys = Object.keys(this.branchData.optometrists[0].schedule),
                // dateKeys = this.branchData.optometrists.filter(optometrist =>  optometrist.schedule != null);
                filteredData = null;
            // go over each of the schedule dates...
            // NOTE: by using SOME() we can stop as soon as the current date is finished being checked, 
            // so we only have to check as much as is necessary to find the first available appointment
            dateKeys.some( date => {
                
                // ... and get the data for each optometrist on that that specific date
                let appointsData = this.branchData.optometrists.map( optometrist => {
                    // get the whole object
                    let optomSchedule = optometrist.schedule[date],
                        // output just the values
                        optomScheduleDatesAvailable = !!optomSchedule ? Object.values(optomSchedule) : [false],
                        // If there is any availability (by the value not being NULL)...
                        hasAvailableDates = optomScheduleDatesAvailable.some( availability => !!availability);

                    // then return the optometrist identifier and the earliest time slot they have
                    if (hasAvailableDates) {
                        // filter out the available dates, then we can grab the first one
                        let earliestAppointment = Object.entries(optomSchedule).filter( date => !!date[1]);
                        return [ optometrist.id, parseInt(earliestAppointment[0][0].replace(':', '')), optometrist.default ];

                    } else {
                        // otherwise can ignore
                        return false
                    }

                }).filter(optometrist => !!optometrist);

                if (!!appointsData.length) {
                    filteredData = appointsData;
                    return true;
                };
                
            });

            // if there is only one result, then we use that
            if (filteredData.length === 1) {
                firstAvailableOptometrist = filteredData[0][0];
            } 
            // otherwise if there is more than one, we need to find the default optometrist or the optometrist with the earliest time
            else if (filteredData.length > 1) {
                const defaultOptometrist = filteredData.find((data) => data[2]);
                if (defaultOptometrist) {
                    firstAvailableOptometrist = defaultOptometrist[0]
                } else {
                    // sort into ascending order
                    let sortedByTime = filteredData.sort((a, b) => a[1] - b[1]);
                    firstAvailableOptometrist = sortedByTime[0][0];
                }
            }

            this.firstOptom = firstAvailableOptometrist;
            // this.selectedOptometrist = this.branchData.optometrists.find( optometrist => optometrist.id === this.firstOptometrist);

        },

        _getBranchAppointments() {
            axios.get(`${APPOINT_DATA_URL}${this.booking.branch_identifier}`, xhrRequestConfig)
                    .then( response => {
                        let data = response.data;
                        return data;
                    })
                    .then( data => {
                        if (!!data.success) {
                            // Filter out the Optometrists that have no availabilities
                            let filteredOptoms = data.data.branch.optometrists.filter( optom => {
                                return Object.values(optom.schedule).some(timeslot => !!timeslot)
                            }),
                                branchDataUpdated = {
                                    ...data.data.branch,
                                    optometrists: filteredOptoms
                                };
                            
                            this.branchData = branchDataUpdated;
                            this._findFirstOrDefaultAvailableAppointment();
                            this.booking.optometrist_id = 'any';
                            this.isSubmitting = false;
                            this._goToStep(3);
                        } else {
                            this._handleErrors(true, data);
                        }
                    })
                    .catch( error => {
                        console.error(error);
                        this.isSubmitting = false;
                    });
        },
        
        _postForm(url) {
            let formData = {
                // User Data
                "accepts_marketing": this.user.rejects_marketing === 'true' ? true : false,
                "date_of_birth": this.user.date_of_birth,
                "email":this.user.email,
                "first_name": this.user.first_name,
                "title": this.user.title,
                "last_name": this.user.last_name,
                "phone": this.user.phone,

                // Booking Data
                "branch_id": this.booking.branch_identifier,
                "date": this.booking.date,
                "optometrist_id": this.isAnyOptometrist ? this.anyOptometristID : this.booking.optometrist_id,
                "type": this.booking.type,
                "time": this.booking.time,
            };

            // AXIOS POST to APPOINT_CREATE_URL

            axios.post(`${APPOINT_CREATE_URL}`, formData, xhrRequestConfig)
                .then( response => {
                    let data = response.data;
                    return data;
                })
                .then( data => {
                    this.isSubmitting = false;
                    if (!!data.success) {
                        this.isSubmitting = false;
                        if(url){
                            window.location.href = url;
                        }else{
                            this._goToStep(5);
                        }
                        
                    } else {
                        this._handleErrors(true, data);
                    }
                })
                .catch( error => {
                    console.error(error);
                    this._handleErrors(true, error.response.data);
                    this.isSubmitting = false;
                });
        },
        
        // Step Controls
        _goToStep(step, reset = false, resetType = false) {
            
            this._handleErrors(false);
            this.leavingAlertClose();
            
            this.removeLeaveAlert = false;

            // If not refreshing the page scroll the top and change the step
            if (!resetType) {
                this.step = step;
                window.scroll({ top: 0, left: 0, behavior: 'smooth' });
            }

            if (reset) {
                this._resetFormData(resetType);
            }
        },
        
        _generateOrdinalDate(date) {
            // Yoinked from https://leancrew.com/all-this/2020/06/ordinal-numerals-and-javascript/
            var s = ["th", "st", "nd", "rd"];
            var v = date%100;
            return date + (s[(v-20)%10] || s[v] || s[0]);
        },
        
        ////////////////////////////////////////////
        // PUBLIC
        ////////////////////////////////////////////

        // Form Controls
        navBarChangeStep(step) {
            if (step === 1) {
                this.clearSearchParams()
                this._goToStep(step, true, true)
            } else {
                this._goToStep(step, true, false)
            }
        },
        formSelectStore(id) {
            this.booking.branch_identifier = id;
            this.currentUrl.searchParams.set('store', id)
            window.history.pushState({}, '', this.currentUrl)

            this._goToStep(2);
        },
        formSelectType(type) {
            this.isSubmitting = true;
            this.booking.type = type;
            this._getBranchAppointments();
        },
        formSelectDateTime() {
            if (this._validation(3)) this._goToStep(4);
        },
        formSubmit(url) {
            this.isSubmitting = true;
            if (this._validation(4)) { 
                /*********************
                TODO: 
                -> SUBMIT FORM
                -> HANDLE RESPONSE
                    -> IF SUCCESS: SHOW STEP 5
                    -> SHOW MESSAGE IF ERROR/ NO BOOKINGS/ BRANCH CLOSED
                *********************/
               gtag('event', 'conversion', {'send_to': 'AW-969129079/P9PECJrH0dgDEPf4js4D'});
               this._postForm(url);
            } else {
                this.isSubmitting = false;
            }
        },
        formChangeStore() {
            this._goToStep(1, true, true);
        },
        formChangeAppointment() {
            this._goToStep(3, true, false);
        },

        getDay(date) {
            let dateFull = new Date(date);
            return new Intl.DateTimeFormat('en-AU', { weekday: 'short'}).format(dateFull);
        },
        getDate(date) {
            let dateFull = new Date(date);
            return `${dateFull.getDate()}/${(dateFull.getMonth() + 1)}`
        },
        getDateTitle(date) {
            let dateFull = new Date(date),
                dateParts = new Intl.DateTimeFormat('en-AU', { weekday: 'long', day: 'numeric', month: 'long' }).formatToParts(dateFull),
                dateFormatted = `${dateParts.find( date => date.type === 'weekday').value} ${this._generateOrdinalDate(dateParts.find( date => date.type === 'day').value)} ${dateParts.find( date => date.type === 'month').value}`;
            
            return dateFormatted
        },

        leavingAlertTrigger() {
            if (this.step === 3 || this.step === 4) {
                this.showLeaveAlert = true;
            } else {
                this.showLeaveAlert = false;
            }
        },
        leavingAlertClose() {
            if (this.step === 3 || this.step === 4) {
                this.showLeaveAlert = false;
                this.removeLeaveAlert = true;
            }
        },
        leavingAlertLeave() {
            if (this.step === 3 || this.step === 4) {
                window.location.href = "/";
            }
        },
        toggleReadMore () {
            this.isReadingMore = !this.isReadingMore
        },
        clearSearchParams() {
            this.currentUrl.search = ''
            window.history.pushState({}, '', this.currentUrl)
        }
    }
}